import { PagedResult } from "@king-ict/eupisi-ui/models";

import type { Selectable } from "../../../../models";
import type {
  SaveSchoolCandidateInstitutionAssignment,
  SchoolCandidateResidenceChange,
} from "../../../../models/SchoolCandidate";

export const hasSelectedCandidates = (
  update: SaveSchoolCandidateInstitutionAssignment
) => {
  return !!update.schoolCandidateList.length;
};

export const hasSelectedCandidatesInstitutionAndRequest = (
  update: SaveSchoolCandidateInstitutionAssignment,
  tableData: PagedResult<SchoolCandidateResidenceChange & Selectable>
) => {
  const selectedSchoolCandidatesSet = new Set(update.schoolCandidateList);
  const selectedSchoolCandidates = tableData.results.filter((candidate) =>
    selectedSchoolCandidatesSet.has(candidate.schoolCandidateId)
  );

  if (!selectedSchoolCandidates?.length) return false;

  return selectedSchoolCandidates.every(
    (sc) => !sc.hasRequest && !sc.newAdressApproved && !sc.institutionId
  );
};

export const hasAnySelectedWithInstitution = (
  update: SaveSchoolCandidateInstitutionAssignment,
  tableData: PagedResult<SchoolCandidateResidenceChange & Selectable>
) => {
  return tableData.results.some((candidate) => {
    const isSelected = update.schoolCandidateList.some(
      (id) => id === candidate.schoolCandidateId
    );

    return isSelected && !!candidate.institutionId;
  });
};

export const createNextSelection = (
  currentSelected: number[],
  schoolCandidateId: number,
  isChecked: boolean
): number[] => {
  if (isChecked) {
    if (currentSelected.includes(schoolCandidateId)) {
      return currentSelected;
    }

    return [...currentSelected, schoolCandidateId];
  }

  return currentSelected.filter((id) => id !== schoolCandidateId);
};

export const partitionSelectedByNewAddress = (
  selectedCandidates: (SchoolCandidateResidenceChange & Selectable)[]
) => {
  const invalidCandidates: SchoolCandidateResidenceChange[] = [];
  const validIds: number[] = [];

  const hasNoNewAddress = (candidate: SchoolCandidateResidenceChange) =>
    !candidate.newPermanentResidence && !candidate.newTemporaryResidence;

  for (const candidate of selectedCandidates) {
    if (hasNoNewAddress(candidate)) {
      invalidCandidates.push(candidate);
    } else {
      validIds.push(candidate.schoolCandidateId);
    }
  }

  return { invalidCandidates, validIds };
};
